import { Injectable } from "@angular/core";
import { RestService } from "./rest.service";
import { BehaviorSubject } from "rxjs";
import { ToastService } from "@msi/cobalt";

@Injectable({
    providedIn: 'root',
  })
  export class TenantSettings {
    public editEnabled: BehaviorSubject<boolean> = new BehaviorSubject(true);
    constructor(private rest: RestService, private toastService: ToastService) {
        this.rest.getCustomerTenantId().subscribe(id => {
            this.rest.getTenatSize(id).subscribe((tenantInfo: any) => {
                const editEnabled = tenantInfo.phzEditEnabled;
                this.editEnabled.next(tenantInfo.phzEditEnabled);
                if(editEnabled !== true){
                    this.toastService.warning(`Editing of premise hazard data is disabled for this customer. Contact support to enable this feature.`);
                }
            });
        })
    }
  }